<template>
  <div class="inquiry-shop-infor">
    <div class="inquiry-shop-infor__wrap">
      <p class="font-bold">{{ $t('common.inquiryNote.titleCaution') }}</p>
      <p class="text-left inquiry-shop-infor--line">
        <span>
          {{ $t('common.inquiryNote.note1-1') }}
        </span>
        <br />
        <span class="font-bold">
          {{ $t('common.inquiryNote.note1-2') }}
        </span>
        <br />
        <span>
          {{ $t('common.inquiryNote.note1-3') }}
        </span>
        <br />
        <span>
          {{ $t('common.inquiryNote.note1-4') }}
        </span>
        <br />
        <span>
          {{
            $t('common.inquiryNote.note1-5', {
              phoneAndTime: `${Utils.helper.formatPhoneNumber(shop.phone_number)} ${shop.business_hour}`,
            })
          }}
        </span>
        <br />
        <span>{{ $t('common.inquiryNote.note2-1') }}</span>
        <a class="text-blue-650 underline" :href="Constants.SHOP_CONFIG.FAQ_URL" target="_blank">{{
          $t('common.inquiryNote.note2-link')
        }}</a>
        <span>{{ $t('common.inquiryNote.note2-2') }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    shop() {
      return this.$store.getters['auth/shop']
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/inquiry-shop-infor.scss';
</style>
